import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import NotificationToastContainer from './components/NotificationToastContainer';
import './styles/theme.scss';

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <AuthProvider>
        <NotificationProvider>
          <Layout>
            <Routes>
              {AppRoutes.map((route, index) => {
                const { element, ...rest } = route;
                return <Route key={index} {...rest} element={element} />;
              })}
            </Routes>
          </Layout>
          <NotificationToastContainer />
        </NotificationProvider>
      </AuthProvider>
    );
  }
}
